import React, { Component } from "react";
import { Button } from "semantic-ui-react";

import * as types from "../../constants";
import SemanticUiModal from "../../components/modal";
import ElementLoader from "../../components/element_loader";
import LibraryControlForm from "./library_control_form";
import { getText } from "../../helpers";

import "semantic-ui-css/semantic.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../../App.css";

function UpdateActions(props) {
  return (
    <div>
      <Button size="medium" className="close-button" onClick={props.hideUpdateControl}>
        {getText("Cancel")}
      </Button>
      <Button positive size="medium" className="update-control-button" onClick={props.updateLibraryControl} disabled={props.isLoading}>
        {getText("Update")}
        <div className="position-relative">
          <ElementLoader isLoading={props.isLoading} message=" " />
        </div>
      </Button>
    </div>
  );
}

export default class UpdateLibraryControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  updateLibraryControl = () => {
    this.setState({ isLoading: true }, this.props.updateLibraryControl);
  };

  componentWillReceiveProps = (nextProps) => {
    if (types.UPDATE_LIBRARY_CONTROL_FAILURE === nextProps.actionType) {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const modalOptions = { className: "update-control", size: "tiny" };
    return (
      <SemanticUiModal
        modalOptions={modalOptions}
        header={getText("Update Library Control")}
        content={
          <LibraryControlForm
            control={this.props.control}
            controlErrors={this.props.controlErrors}
            handleControlChange={this.props.handleControlChange}
            defaultTagOptions={this.props.defaultTagOptions}
            defaultOwnerOptions={this.props.defaultOwnerOptions}
            updateOwners={this.props.updateOwners}
            createNewOwner={this.props.createNewOwner}
            removeOwner={this.props.removeOwner}
            updateTags={this.props.updateTags}
            createNewTag={this.props.createNewTag}
            removeTag={this.props.removeTag}
            translations={this.props.translations}
          />
        }
        actions={
          <UpdateActions
            hideUpdateControl={this.props.hideUpdateControl}
            updateLibraryControl={this.updateLibraryControl}
            isLoading={this.state.isLoading}
          />
        }
        closeModal={this.props.hideUpdateControl}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/control_library/update_library_control.js